import axios from 'axios'

class BranchOfficeService {
  constructor(apiUrl) {
    this.apiUrl = apiUrl
  }

  /**
   * @author Isaac Martinez
   * @description  Get branch offices by clientId
   * @status no delete
   * @param {String} token
   * @returns {Object}
   * @memberof BranchOfficeService
   */
  async getBranchOffices(token) {
    let response = await axios.get(`${this.apiUrl}/branch-offices`, {
      headers: {
        'Authorization': `Bearer ${token}`
      },
    })
    if (response.data.statusCode !== 200) {
      throw new Error(response.data.message)
    }
    return response.data.data
  }

  /**
   * @author Brayan Salas
   * @description Create new branch office
   * @status no delete
   * @param {String} token
   * @returns {Object}
   * @memberof BranchOfficeService
   */
  async createBranchOffice(nameRef, zipCodeRef, cityRef, stateRef, countryRef, keyIdentifierRef, fullAddress, coordinates, token) {
    let response = await axios.post(`${this.apiUrl}/branch-office`,
      {
        "name": nameRef,
        "fullAddress": fullAddress,
        "zipCode": zipCodeRef,
        "city": cityRef,
        "state": stateRef,
        "country": countryRef,
        "keyIdentifier": keyIdentifierRef,
        "coordinates": coordinates
      },
      {
        headers: {
          'Authorization': `Bearer ${token}`
        },
      })

    if (response.data.statusCode !== 200) {
      throw new Error(response.data.message)
    }

    return response.data.data
  }

  /**
   * @author Isaac Martinez
   * @description  Get branch offices by clientId
   * @status no delete
   * @param {String} token
   * @returns {Object}
   * @memberof BranchOfficeService
   */
  async getBranchOfficeById(branchOfficeId, token) {
    let response = await axios.get(`${this.apiUrl}/branch-office?branchOfficeId=${branchOfficeId}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      },
    })
    if (response.data.statusCode !== 200) {
      throw new Error(response.data.message)
    }
    return response.data.data
  }

  /**
   * @author Brayan Salas
   * @description Update branch office
   * @status no delete
   * @param {String} token
   * @returns {Object}
   * @memberof BranchOfficeService
   */
  async updateBranchOffice(branchOfficeId, nameRef, zipCodeRef, cityRef, stateRef, countryRef, keyIdentifierRef, fullAddress, coordinates, token) {
    let response = await axios.put(`${this.apiUrl}/branch-office`,
      {
        branchOfficeId,
        "name": nameRef,
        "fullAddress": fullAddress,
        "zipCode": zipCodeRef,
        "city": cityRef,
        "state": stateRef,
        "country": countryRef,
        "keyIdentifier": keyIdentifierRef,
        "coordinates": coordinates
      },
      {
        headers: {
          'Authorization': `Bearer ${token}`
        },
      })
    if (response.data.statusCode !== 200) {
      throw new Error(response.data.message)
    }
    return response.data.data
  }

  /**
   * @author Brayan Salas
   * @description Delete branch office
   * @status no delete
   * @param {String} token
   * @returns {Object}
   * @memberof BranchOfficeService
   */
  async deleteBranchOffice(branchOfficeId, token) {
    let response = await axios.delete(`${this.apiUrl}/branch-office?branchOfficeId=${branchOfficeId}`,
      {
        headers: {
          'Authorization': `Bearer ${token}`
        },
      })
    if (response.data.statusCode !== 200) {
      throw new Error(response.data.message)
    }
    return response.data.data
  }

  async massiveBranchOffices(branchOffices, token) {
    let response = await axios.post(`${this.apiUrl}/branch-office-csv`, { branchOffices }, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    return response.data
  }
}
export { BranchOfficeService as default }